import type { SVGProps } from 'react';

import { useSvgIdPrefix } from '../../svg-ids';

const ReactComponent = (props: SVGProps<SVGSVGElement>) => {
  const uid = useSvgIdPrefix('gold-medal');

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 -2 76 76"
      {...props}
    >
      <g filter={`url(#${uid}a)`}>
        <path
          fill="#002942"
          fillRule="evenodd"
          d="M38 66c16.569 0 30-13.431 30-30C68 19.432 54.569 6 38 6 21.432 6 8 19.432 8 36c0 16.569 13.432 30 30 30"
          clipRule="evenodd"
        />
      </g>
      <path
        fill="#FFDA65"
        fillRule="evenodd"
        d="M31.045 39.688v16.494l6.954-5.432 6.953 5.432V39.669"
        clipRule="evenodd"
      />
      <path
        stroke="#FFC23B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M31.045 39.688v16.494l6.954-5.432 6.953 5.432V39.669"
      />
      <path
        fill="#FFDA65"
        fillRule="evenodd"
        stroke="#FFC23B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M38.001 41.504c7.093 0 12.843-5.75 12.843-12.843s-5.75-12.843-12.843-12.843-12.843 5.75-12.843 12.843 5.75 12.843 12.843 12.843"
        clipRule="evenodd"
      />
      <defs>
        <filter
          id={`${uid}a`}
          width={76}
          height={76}
          x={0}
          y={0}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={4} />
          <feColorMatrix values="0 0 0 0 0.377388 0 0 0 0 0.314314 0 0 0 0 0.956522 0 0 0 0.25601 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};
export { ReactComponent };
